/* DO NOT MODIFY FILE, IT IS READ-ONLY. Make a merge request to the widget template to modify. */
import {importWidgetModule as importModule} from '@skbkontur/loader-builder';
import type {
	AddImportWidgetModuleFaults,
	AddImportWidgetModuleViaIFrameDisposeFaults,
	Disposable,
} from '@skbkontur/loader-builder';
import type {OperationResult} from '@skbkontur/operation-result';
import {dependencies} from './dependencies.js';
import type {ConfigureIframeDisposeFaults, Dependencies, JsLoaderImportFaults} from './internalTypes.js';
import type {
	ImportDependencies,
	DisposeFaults as InternalDisposeFaults,
	WidgetApi as InternalWidgetApi,
} from './userTypes.js';

export type ImportParams = {
	readonly widgetUrl: URL;
} & ImportDependencies;

export type ImportFaults = AddImportWidgetModuleFaults<JsLoaderImportFaults>;

export type DisposeFaults = AddImportWidgetModuleViaIFrameDisposeFaults<
	InternalDisposeFaults,
	ConfigureIframeDisposeFaults
>;

export type WidgetApi = Disposable<DisposeFaults> & InternalWidgetApi;

export function importWidgetModule({
	widgetUrl,
	...importDependencies
}: ImportParams): Promise<OperationResult<ImportFaults, WidgetApi>> {
	return importModule<Dependencies, JsLoaderImportFaults, WidgetApi>({
		widgetUrl,
		dependencies: {
			...dependencies,
			...importDependencies,
		},
	});
}

export function inferCandyWidgetUrlFromCandyApiUrl(candyApiUrl: URL): URL {
	const url = new URL(trimLastSlash(candyApiUrl.toString()));
	url.pathname = trimLastSlash(url.pathname) + "/static/candy-widget/widget/loader.js";
	return url;
}

export function inferCabinetApiUrlFromKeformsUrl(keformsUrl: string): string {
    if (keformsUrl.startsWith("https://api-") || keformsUrl.startsWith("https://localhost")) {
        return "https://api.testkontur.ru/cabinet-api";
    }
    return keformsUrl.replace("/candy", "/cabinet-api");
}

export function trimLastSlash(url: string): string {
	return url.slice(-1) === "/" ? url.slice(0, -1) : url;
}
